
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexM0wj17x4y0uaUumupQDLBGc5OIfNrjyTt1WxmM49YfoMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/index.vue?macro=true";
import { default as indexA5mYFs7QPOPWSC8iKNtj_45lNjiPAesgtlsoRGcN_45jm88Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/login/index.vue?macro=true";
import { default as set_45workspaceGmZ9hbt_45ZFl5ibpxQECLCPS3VVA_45FACKUDlp2rqXVzQMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/set-workspace.vue?macro=true";
import { default as indexV097_45u_ZbBoxHe303915VCIBkmSV1X90OfGI1T63p2AMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/sign-up/index.vue?macro=true";
import { default as indexaFF70fp6FQrFQUdulq1tN7j7_4541ntsTxC_R86LtQrLYMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/magic-link/index.vue?macro=true";
import { default as indexRLY82m_45q0reSZVrXQf8QfWRXHe9HiGISkGQFKM7L_vQMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/index.vue?macro=true";
import { default as indexpWgq_45fMjtW_45zwlCewpGPE59JlyfwLuyCkLk6HyPvxNgMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue?macro=true";
import { default as new6_PSejhSgC_450DZsrt_0BfXdGCxG6KyIvVH0t9icZd9QMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue?macro=true";
import { default as account_45configurationQNQYctCEDvmYgr6dOGhvuTH_malcMvZ1t8ZPpkCfIv8Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue?macro=true";
import { default as indexAII_moHKTXVfcI29_45j04Vz0SsaCViJqoVvvvqW8BEoUMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue?macro=true";
import { default as mZ6QyLXye3Mh5iCzk0MLo4vGQC5oZT9owdczNnTq_0VYMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m.vue?macro=true";
import { default as indexohvlOtVqKKEsNYdLKUBobCpyeSZ5lYLvXP6YVMJaeCwMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/reset-password/index.vue?macro=true";
import { default as indexuJNbXNmgKlr62uacdFdoWu5oPumCl9Q15cZFW2pNquYMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/index.vue?macro=true";
import { default as index_hb1B8BoG2HEGxr41kDfowQZZdskahBgtfQL4_mKFOIMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue?macro=true";
import { default as indexOjDS650zgLZBvzyjBwlRYlBxRpySWOg_45NpoGLx_VvzkMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue?macro=true";
import { default as user_45signuppUAVmW0mREipZThSm9pCl9hXafUF0JH78_5EHumJ64gMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue?macro=true";
import { default as index8tuj8zxP91TcfgyTwXoRhW_XaeurnTwwgHY07ckKMd4Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue?macro=true";
import { default as indexOkYSkafmcLSTSDD0sUH3_kiW7BmhwG_LTZk_fRnj6G0Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue?macro=true";
import { default as indexVR_45NWFYPBngoLCg42CsSJh3yqiw3sWxzq_gRrWswSvsMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue?macro=true";
import { default as new1vRuqYSZMUU96VWVoJGq_45k4S4BAZy0xaTey2pMJN3KIMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue?macro=true";
import { default as _91id_93bqPWZUBqUUpAcetpr2dlXZSkVSiaxY0KBe1Q7je1SvoMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue?macro=true";
import { default as indexmyRqwwShHCCY1J_dhH46rNXTmBY8_z0psW9lygcm4OIMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue?macro=true";
import { default as indexPAccsA1DTXcYJYjs_Z938SaOEBdtKjkTuvvSCN8Jcl4Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue?macro=true";
import { default as indexjwS0bb2ZOCWQD1df_45UXT_1gW_tJ2BVES0nIlUl58eQ0Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue?macro=true";
import { default as indexHpeiH_45z72UvSNwkzlPeJE71RuhJKEc6T0JkecOF2OTUMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue?macro=true";
import { default as indexRNOkb2c4ikbdjSxPo4nAQ9qxfwTjRoQBM8UMDPbxowwMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue?macro=true";
import { default as indexeEKvlE6_452dvRqQkqD1Y1Fn0iC_4512jeH86kVNWni4fwYMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue?macro=true";
import { default as indexRCN8qu70cAz_45xMLI3Qsmau90zFECv_45iSFBXFE_45D9ZX0Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue?macro=true";
import { default as _91providerSlug_935VtDl6St7t6Z__u5AAm_45D_9QbutVZaVq6vdNfRdKIUEMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue?macro=true";
import { default as indexw0V6DS_9pM7XaqGFpl4JkbaLGXbUQ_45Df_uSmmgkskXQMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue?macro=true";
import { default as settingsPlzlSiF6WS0_45xNfx05JVigrXuICcP3TZniuBPhOUXtoMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue?macro=true";
import { default as indexFfytb_b3va5a2O0TsNzJmL1M_45ZKouE_452qwgmHDOkRisMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue?macro=true";
import { default as _91id_93cNVVCUw8laCWmRmI_xLefC146OZjXBBRFSlgiGWRYCgMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue?macro=true";
import { default as indexmHlthEmdCkmob4Eo81zSC1heXleuo6ca8_458T_JCmX5YMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue?macro=true";
import { default as index3uXQZu3V891EEeJ_45Ohpq_Bo_45NTmUx_l8v27ZvmBkCmwMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue?macro=true";
import { default as import8MqVolMFzdHXAEqxYxep4k_IT1NzL4OIFMIZjcNlLugMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue?macro=true";
import { default as schemaPISleUX0pFUABAKsQ9h_45UB4u2ePTYojYVHYygwyp_45G0Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue?macro=true";
import { default as indexv8TaEa4DmAC7ySB4SHtppibIZFW_yCDHbTvyGsnVB4YMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue?macro=true";
import { default as indexSrBm7Be3C8uMpdbBi68t3ijDzKksg_2fV5DhkjI9DC8Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue?macro=true";
import { default as historyytTRLPbE2VMyEbOOp7maTkUbp_45p8p98FuoTRC7_45cmZsMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue?macro=true";
import { default as studioN_45nZVIGyYsR_458r5aqnEjvz_fOSkqoj5E8OcPahDNTUAMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio.vue?macro=true";
import { default as index__45WDw77LZ55BsA1fb1iJ9LGSpR8CW1mojvzn13_jG9EMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/p/index.vue?macro=true";
import { default as index7EKWA6Zi4HHpb2MLrnteSilnmdhYLptfUwjzuJHYNnoMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue?macro=true";
import { default as indexiZmkOW1nwMvcjgqFV2UiONFRN88RHR5egmngKGu1od4Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/login/index.vue?macro=true";
import { default as indexkagDD63IFgqlXN3Jwot0j0D4APOWoD6OPb7W5D35amUMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/store/index.vue?macro=true";
import { default as _91app_93jXij4Yx9uuEFG5MmGK5dP0M6xXXE7lh89BCzL_hOZP4Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue?macro=true";
import { default as indexe0rYo4C3JXw4zKN0csf_ITqJ_45yqku8F4gQ7E8oc7XUwMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue?macro=true";
import { default as indexnowKEq_0fuygNimua_l8yH59jlcG9XD9oPAxADiNlZkMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue?macro=true";
import { default as reset_45passwordWinv2G9iqRin3l6pUwKYHaayvmevriuVQLuvnH1KPtsMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue?macro=true";
import { default as index1bI9_8SFRivG_Lg9GkLn7BYOu4kSxGYphKwlWiTowAUMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue?macro=true";
import { default as indexmFIoMgH33YH7jcbFVlic5bb9QbNgbKA6TG3VeCPXYPYMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue?macro=true";
import { default as indexpVP8iQakyO3oGltecNbpq7ZGO_jEXGK1LtzT_451h3e2sMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue?macro=true";
import { default as _91appName_93Szsd44W_45LB9AT35buAxlrFF1EhBdYwfY1Cx7QIGOJKcMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue?macro=true";
import { default as indexOlDqBrzepFbmWwBeOvxw5VijhKgEusm6_45kjX0hmaEBIMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue?macro=true";
import { default as index3TODwmwY9Gmgb_45YS5zWqXI0_45iudKzL_45vNroRemZNBQEMeta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue?macro=true";
import { default as indexBy8TbYzF42Q5_45X0q8GLv0SIFaKSKSS98knOopwBeDk4Meta } from "/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    meta: indexM0wj17x4y0uaUumupQDLBGc5OIfNrjyTt1WxmM49YfoMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/",
    meta: indexM0wj17x4y0uaUumupQDLBGc5OIfNrjyTt1WxmM49YfoMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "login___pt",
    path: "/login",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "set-workspace___en",
    path: "/en/set-workspace",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "set-workspace___pt",
    path: "/set-workspace",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "sign-up___en",
    path: "/en/sign-up",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___pt",
    path: "/sign-up",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "magic-link___en",
    path: "/en/magic-link",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: "magic-link___pt",
    path: "/magic-link",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: mZ6QyLXye3Mh5iCzk0MLo4vGQC5oZT9owdczNnTq_0VYMeta?.name,
    path: "/en/t/:tenantSlug()/m",
    meta: mZ6QyLXye3Mh5iCzk0MLo4vGQC5oZT9owdczNnTq_0VYMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___en",
    path: "",
    meta: indexRLY82m_45q0reSZVrXQf8QfWRXHe9HiGISkGQFKM7L_vQMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___en",
    path: ":viewId()",
    meta: indexpWgq_45fMjtW_45zwlCewpGPE59JlyfwLuyCkLk6HyPvxNgMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___en",
    path: ":viewId()/r/new",
    meta: new6_PSejhSgC_450DZsrt_0BfXdGCxG6KyIvVH0t9icZd9QMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___en",
    path: "account-configuration",
    meta: account_45configurationQNQYctCEDvmYgr6dOGhvuTH_malcMvZ1t8ZPpkCfIv8Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___en",
    path: ":viewId()/r/:recordId()",
    meta: indexAII_moHKTXVfcI29_45j04Vz0SsaCViJqoVvvvqW8BEoUMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: mZ6QyLXye3Mh5iCzk0MLo4vGQC5oZT9owdczNnTq_0VYMeta?.name,
    path: "/t/:tenantSlug()/m",
    meta: mZ6QyLXye3Mh5iCzk0MLo4vGQC5oZT9owdczNnTq_0VYMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___pt",
    path: "",
    meta: indexRLY82m_45q0reSZVrXQf8QfWRXHe9HiGISkGQFKM7L_vQMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___pt",
    path: ":viewId()",
    meta: indexpWgq_45fMjtW_45zwlCewpGPE59JlyfwLuyCkLk6HyPvxNgMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___pt",
    path: ":viewId()/r/new",
    meta: new6_PSejhSgC_450DZsrt_0BfXdGCxG6KyIvVH0t9icZd9QMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___pt",
    path: "account-configuration",
    meta: account_45configurationQNQYctCEDvmYgr6dOGhvuTH_malcMvZ1t8ZPpkCfIv8Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___pt",
    path: ":viewId()/r/:recordId()",
    meta: indexAII_moHKTXVfcI29_45j04Vz0SsaCViJqoVvvvqW8BEoUMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___pt",
    path: "/reset-password",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "t-tenantSlug___en",
    path: "/en/t/:tenantSlug()",
    meta: indexuJNbXNmgKlr62uacdFdoWu5oPumCl9Q15cZFW2pNquYMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: "t-tenantSlug___pt",
    path: "/t/:tenantSlug()",
    meta: indexuJNbXNmgKlr62uacdFdoWu5oPumCl9Q15cZFW2pNquYMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: studioN_45nZVIGyYsR_458r5aqnEjvz_fOSkqoj5E8OcPahDNTUAMeta?.name,
    path: "/en/t/:tenantSlug()/studio",
    meta: studioN_45nZVIGyYsR_458r5aqnEjvz_fOSkqoj5E8OcPahDNTUAMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___en",
    path: "",
    meta: index_hb1B8BoG2HEGxr41kDfowQZZdskahBgtfQL4_mKFOIMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsPlzlSiF6WS0_45xNfx05JVigrXuICcP3TZniuBPhOUXtoMeta?.name,
    path: "settings",
    meta: settingsPlzlSiF6WS0_45xNfx05JVigrXuICcP3TZniuBPhOUXtoMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___en",
    path: "",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___en",
    path: "user-signup",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___en",
    path: "users",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___en",
    path: "tokens",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___en",
    path: "internal",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___en",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___en",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___en",
    path: "app-builder",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___en",
    path: "export-data",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___en",
    path: "user-groups",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___en",
    path: "integrations",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___en",
    path: "authentication",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___en",
    path: "email-analytics",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___en",
    path: "system-entities",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___en",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___en",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___en",
    path: "data",
    meta: indexFfytb_b3va5a2O0TsNzJmL1M_45ZKouE_452qwgmHDOkRisMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___en",
    path: "pages/:id()",
    meta: _91id_93cNVVCUw8laCWmRmI_xLefC146OZjXBBRFSlgiGWRYCgMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___en",
    path: "pages",
    meta: indexmHlthEmdCkmob4Eo81zSC1heXleuo6ca8_458T_JCmX5YMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___en",
    path: "data/:id()",
    meta: index3uXQZu3V891EEeJ_45Ohpq_Bo_45NTmUx_l8v27ZvmBkCmwMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___en",
    path: "data/:id()/import",
    meta: import8MqVolMFzdHXAEqxYxep4k_IT1NzL4OIFMIZjcNlLugMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___en",
    path: "data/:id()/schema",
    meta: schemaPISleUX0pFUABAKsQ9h_45UB4u2ePTYojYVHYygwyp_45G0Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___en",
    path: "automations",
    meta: indexv8TaEa4DmAC7ySB4SHtppibIZFW_yCDHbTvyGsnVB4YMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___en",
    path: "automations/:id()",
    meta: indexSrBm7Be3C8uMpdbBi68t3ijDzKksg_2fV5DhkjI9DC8Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___en",
    path: "automations/:id()/history",
    meta: historyytTRLPbE2VMyEbOOp7maTkUbp_45p8p98FuoTRC7_45cmZsMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: studioN_45nZVIGyYsR_458r5aqnEjvz_fOSkqoj5E8OcPahDNTUAMeta?.name,
    path: "/t/:tenantSlug()/studio",
    meta: studioN_45nZVIGyYsR_458r5aqnEjvz_fOSkqoj5E8OcPahDNTUAMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___pt",
    path: "",
    meta: index_hb1B8BoG2HEGxr41kDfowQZZdskahBgtfQL4_mKFOIMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsPlzlSiF6WS0_45xNfx05JVigrXuICcP3TZniuBPhOUXtoMeta?.name,
    path: "settings",
    meta: settingsPlzlSiF6WS0_45xNfx05JVigrXuICcP3TZniuBPhOUXtoMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___pt",
    path: "",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___pt",
    path: "user-signup",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___pt",
    path: "users",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___pt",
    path: "tokens",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___pt",
    path: "internal",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___pt",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___pt",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___pt",
    path: "app-builder",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___pt",
    path: "export-data",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___pt",
    path: "user-groups",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___pt",
    path: "integrations",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___pt",
    path: "authentication",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___pt",
    path: "email-analytics",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___pt",
    path: "system-entities",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___pt",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___pt",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___pt",
    path: "data",
    meta: indexFfytb_b3va5a2O0TsNzJmL1M_45ZKouE_452qwgmHDOkRisMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___pt",
    path: "pages/:id()",
    meta: _91id_93cNVVCUw8laCWmRmI_xLefC146OZjXBBRFSlgiGWRYCgMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___pt",
    path: "pages",
    meta: indexmHlthEmdCkmob4Eo81zSC1heXleuo6ca8_458T_JCmX5YMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___pt",
    path: "data/:id()",
    meta: index3uXQZu3V891EEeJ_45Ohpq_Bo_45NTmUx_l8v27ZvmBkCmwMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___pt",
    path: "data/:id()/import",
    meta: import8MqVolMFzdHXAEqxYxep4k_IT1NzL4OIFMIZjcNlLugMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___pt",
    path: "data/:id()/schema",
    meta: schemaPISleUX0pFUABAKsQ9h_45UB4u2ePTYojYVHYygwyp_45G0Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___pt",
    path: "automations",
    meta: indexv8TaEa4DmAC7ySB4SHtppibIZFW_yCDHbTvyGsnVB4YMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___pt",
    path: "automations/:id()",
    meta: indexSrBm7Be3C8uMpdbBi68t3ijDzKksg_2fV5DhkjI9DC8Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___pt",
    path: "automations/:id()/history",
    meta: historyytTRLPbE2VMyEbOOp7maTkUbp_45p8p98FuoTRC7_45cmZsMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: "t-tenantSlug-p___en",
    path: "/en/t/:tenantSlug()/p",
    meta: index__45WDw77LZ55BsA1fb1iJ9LGSpR8CW1mojvzn13_jG9EMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-p___pt",
    path: "/t/:tenantSlug()/p",
    meta: index__45WDw77LZ55BsA1fb1iJ9LGSpR8CW1mojvzn13_jG9EMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___en",
    path: "/en/t/:tenantSlug()/mfa",
    meta: index7EKWA6Zi4HHpb2MLrnteSilnmdhYLptfUwjzuJHYNnoMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___pt",
    path: "/t/:tenantSlug()/mfa",
    meta: index7EKWA6Zi4HHpb2MLrnteSilnmdhYLptfUwjzuJHYNnoMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-login___en",
    path: "/en/t/:tenantSlug()/login",
    meta: indexiZmkOW1nwMvcjgqFV2UiONFRN88RHR5egmngKGu1od4Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-login___pt",
    path: "/t/:tenantSlug()/login",
    meta: indexiZmkOW1nwMvcjgqFV2UiONFRN88RHR5egmngKGu1od4Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-store___en",
    path: "/en/t/:tenantSlug()/store",
    meta: indexkagDD63IFgqlXN3Jwot0j0D4APOWoD6OPb7W5D35amUMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-store___pt",
    path: "/t/:tenantSlug()/store",
    meta: indexkagDD63IFgqlXN3Jwot0j0D4APOWoD6OPb7W5D35amUMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-install-app___en",
    path: "/en/t/:tenantSlug()/install/:app()",
    meta: _91app_93jXij4Yx9uuEFG5MmGK5dP0M6xXXE7lh89BCzL_hOZP4Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-install-app___pt",
    path: "/t/:tenantSlug()/install/:app()",
    meta: _91app_93jXij4Yx9uuEFG5MmGK5dP0M6xXXE7lh89BCzL_hOZP4Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-loading___en",
    path: "/en/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-loading___pt",
    path: "/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___en",
    path: "/en/t/:tenantSlug()/sign-up",
    meta: indexnowKEq_0fuygNimua_l8yH59jlcG9XD9oPAxADiNlZkMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___pt",
    path: "/t/:tenantSlug()/sign-up",
    meta: indexnowKEq_0fuygNimua_l8yH59jlcG9XD9oPAxADiNlZkMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-reset-password___en",
    path: "/en/t/:tenantSlug()/reset-password",
    meta: reset_45passwordWinv2G9iqRin3l6pUwKYHaayvmevriuVQLuvnH1KPtsMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-reset-password___pt",
    path: "/t/:tenantSlug()/reset-password",
    meta: reset_45passwordWinv2G9iqRin3l6pUwKYHaayvmevriuVQLuvnH1KPtsMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___en",
    path: "/en/t/:tenantSlug()/sso/saml",
    meta: index1bI9_8SFRivG_Lg9GkLn7BYOu4kSxGYphKwlWiTowAUMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___pt",
    path: "/t/:tenantSlug()/sso/saml",
    meta: index1bI9_8SFRivG_Lg9GkLn7BYOu4kSxGYphKwlWiTowAUMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___en",
    path: "/en/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___pt",
    path: "/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()",
    meta: indexpVP8iQakyO3oGltecNbpq7ZGO_jEXGK1LtzT_451h3e2sMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___pt",
    path: "/t/:tenantSlug()/p/:viewId()",
    meta: indexpVP8iQakyO3oGltecNbpq7ZGO_jEXGK1LtzT_451h3e2sMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___en",
    path: "/en/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93Szsd44W_45LB9AT35buAxlrFF1EhBdYwfY1Cx7QIGOJKcMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___pt",
    path: "/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93Szsd44W_45LB9AT35buAxlrFF1EhBdYwfY1Cx7QIGOJKcMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-install--review___en",
    path: "/en/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-install--review___pt",
    path: "/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___en",
    path: "/en/t/:tenantSlug()/email-validation",
    meta: index3TODwmwY9Gmgb_45YS5zWqXI0_45iudKzL_45vNroRemZNBQEMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___pt",
    path: "/t/:tenantSlug()/email-validation",
    meta: index3TODwmwY9Gmgb_45YS5zWqXI0_45iudKzL_45vNroRemZNBQEMeta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexBy8TbYzF42Q5_45X0q8GLv0SIFaKSKSS98knOopwBeDk4Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___pt",
    path: "/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexBy8TbYzF42Q5_45X0q8GLv0SIFaKSKSS98knOopwBeDk4Meta || {},
    component: () => import("/codebuild/output/src1539995266/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  }
]